import React from 'react';
import PropTypes from 'prop-types';

/**
 * Header component for the Table
 */
const TableHeader = ({ className, style, columns, renderCell }) => {
  const cells = columns.map((column, columnIndex) => renderCell({ column, columnIndex }));

  return (
    <div className={className} style={style}>
      {cells}
    </div>
  );
};

TableHeader.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  renderCell: PropTypes.func
};

export default TableHeader;
